import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {Paper, Stack, TableContainer, Typography, useTheme} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {ProcedureGroup} from 'domain/usecases';
import {StyledTableHead, StyledTableRow, StyledTypographyHead} from './style';
import {TableMobileRow} from './TableMobileRow';
import {TableDesktopRow} from './TableDesktopRow';
import {TableComponentProps} from './types';

const {code, procedureDescription, price} = translations['pt-br'].privateFlow.franchisesTable;

export function TableComponent({grupos}: TableComponentProps) {
	const theme = useTheme();
	const {isMobile} = useMediaQueries();

	function consolidateItemsByGroup(franchisesGroup: ProcedureGroup[]) {
		const groupMap = new Map<string, ProcedureGroup>();

		franchisesGroup.forEach(item => {
			const {cdGrupo, dsGrupo, procedimentos} = item;

			if (groupMap.has(cdGrupo)) {
				const existingGroup = groupMap.get(cdGrupo)!;
				existingGroup.procedimentos.push(...procedimentos);
			} else {
				groupMap.set(cdGrupo, {
					cdGrupo,
					dsGrupo,
					procedimentos: [...procedimentos],
				});
			}
		});

		return Array.from(groupMap.values());
	}

	const allGroups = consolidateItemsByGroup(grupos);

	return (
		<Stack gap={3}>
			{allGroups.map(group => (
				<div key={group.cdGrupo}>
					<Typography variant="body2" fontWeight={600} color="text.primary" mb={2}>
						{group.dsGrupo}
					</Typography>
					<TableContainer component={Paper} elevation={0}>
						<Table>
							{!isMobile ? (
								<StyledTableHead>
									<StyledTableRow>
										<TableCell align="center" sx={{width: 'auto'}}>
											<StyledTypographyHead>{code}</StyledTypographyHead>
										</TableCell>
										<TableCell
											sx={{
												width: '100%',
											}}>
											<StyledTypographyHead
												sx={{
													borderLeft: `1px solid ${theme.palette.divider}`,
													borderRight: `1px solid ${theme.palette.divider}`,
												}}>
												{procedureDescription}
											</StyledTypographyHead>
										</TableCell>
										<TableCell align="center" sx={{width: 'auto'}}>
											<StyledTypographyHead>{price}</StyledTypographyHead>
										</TableCell>
									</StyledTableRow>
								</StyledTableHead>
							) : null}
							<TableBody sx={{backgroundColor: theme.colors.light.background.paper}}>
								{group.procedimentos.map(procedure => (
									<StyledTableRow
										key={procedure.cdProcedimento}
										sx={{'&:last-child td, &:last-child th': {border: 0}}}>
										{isMobile ? (
											<TableMobileRow {...procedure} />
										) : (
											<TableDesktopRow {...procedure} />
										)}
									</StyledTableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				</div>
			))}
		</Stack>
	);
}
